import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntityFile } from "../../entity/EntityFile";

export class DtoFilesGetRes extends EntityFile {
  public items: EntityFile[]  = [];
}
